import api from '@pray/shared/utils/api';

export async function deleteOrganizationDolly(organizationId: string) {
  const url = `/web/studio/organizations/${organizationId}/dolly`;

  await api.executeDeleteRequest(url);

  return { success: true };
}
